(() => {
  if (window.__ss26GolfCardSwatchesInitialised) return;
  window.__ss26GolfCardSwatchesInitialised = true;

  const swatchSelector = '[data-ss26-card-swatch]';
  const cardSelector = '[data-ss26-product-card]';
  const desktopPointer = () => window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;

  const previewSwatch = (swatch) => {
    const card = swatch.closest(cardSelector);
    if (!card) return;

    const imageUrl = swatch.dataset.ss26SwatchImage;
    const productUrl = swatch.dataset.ss26SwatchUrl || swatch.getAttribute('href');
    const colour = swatch.dataset.ss26SwatchColor;
    const media = card.querySelector('[data-ss26-card-primary-media]');
    const image = media?.querySelector('img');

    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.setAttribute('src', imageUrl);
      image.setAttribute('data-src', imageUrl);
      image.alt = `${card.querySelector('.grid-product__title, .ss26-look-product__title')?.textContent.trim() || ''}／${swatch.dataset.ss26SwatchColor || ''}`;
    }

    if (productUrl) {
      card.querySelectorAll('[data-ss26-card-link]').forEach((link) => {
        link.setAttribute('href', productUrl);
      });
    }

    card.querySelectorAll(swatchSelector).forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-active', selected);
      if (selected) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    const colourLabel = card.querySelector('[data-ss26-card-color]');
    if (colourLabel && colour) colourLabel.textContent = colour;
    card.classList.add('is-ss26-swatch-preview');
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || !desktopPointer()) return;
    previewSwatch(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || desktopPointer()) return;

    event.preventDefault();
    previewSwatch(swatch);
  });
})();
